(function () {
    'use strict';

    function init() {
        var header = document.querySelector('[data-dh-header]');
        if (!header) {
            return;
        }

        var desktopQuery = window.matchMedia('(min-width: 1200px)');
        var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        var items = Array.prototype.slice.call(header.querySelectorAll('.dh-nav-item'))
            .filter(function (item) { return item.querySelector('.dh-mega'); });
        var megaBg = document.getElementById('dh-mega-bg');
        var backdrop = document.getElementById('dh-backdrop');
        var drawer = document.getElementById('dh-drawer');
        var hamburger = document.getElementById('dh-hamburger');
        var dropdowns = Array.prototype.slice.call(header.querySelectorAll('[data-dh-dropdown]'));
        var nav = header.querySelector('.dh-nav');
        var hoverTimer = null;

        var navTriggers = nav ? Array.prototype.slice.call(nav.querySelectorAll('.dh-nav-trigger')) : [];
        var wrappableTriggers = navTriggers.filter(function (trigger) { return /\s/.test(trigger.textContent.trim()); });
        var wrapRatios = [0.55, 0.7, 0.85];

        function navOverflows() {
            return nav.scrollWidth > nav.clientWidth + 1;
        }

        function unwrap(trigger) {
            trigger.classList.remove('dh-wrap');
            trigger.querySelector('.dh-nav-label').style.maxWidth = '';
        }

        function wrap(trigger) {
            var label = trigger.querySelector('.dh-nav-label');
            var width = label.offsetWidth;
            trigger.classList.add('dh-wrap');
            var lineHeight = parseFloat(window.getComputedStyle(label).lineHeight);
            for (var i = 0; i < wrapRatios.length; i++) {
                label.style.maxWidth = Math.ceil(width * wrapRatios[i]) + 'px';
                if (Math.round(label.scrollHeight / lineHeight) <= 2) {
                    return;
                }
            }
            unwrap(trigger);
        }

        function fitNav() {
            header.classList.remove('dh-compact');
            nav.classList.remove('dh-wrapped');
            navTriggers.forEach(unwrap);
            if (!desktopQuery.matches || !navOverflows()) {
                return;
            }

            wrappableTriggers.forEach(wrap);
            nav.classList.add('dh-wrapped');

            if (navOverflows()) {
                navTriggers.forEach(unwrap);
                closeAll();
                header.classList.add('dh-compact');
            }
        }

        if (nav) {
            var fitQueued = false;
            var fitObserver = new ResizeObserver(function () {
                if (fitQueued) {
                    return;
                }
                fitQueued = true;
                window.requestAnimationFrame(function () {
                    fitQueued = false;
                    fitNav();
                });
            });
            fitNav();
            navTriggers.forEach(function (trigger) { fitObserver.observe(trigger); });
            header.querySelectorAll('.dh-tier2, .dh-tier2 .dh-brand, .dh-actions').forEach(function (el) { fitObserver.observe(el); });
        }

        var tabsWrap = header.querySelector('[data-dh-tabs]');
        if (tabsWrap) {
            var tabsNav = tabsWrap.querySelector('.dh-tabs');

            var updateTabArrows = function () {
                var maxScroll = tabsNav.scrollWidth - tabsNav.clientWidth;
                tabsWrap.classList.toggle('can-prev', tabsNav.scrollLeft > 1);
                tabsWrap.classList.toggle('can-next', tabsNav.scrollLeft < maxScroll - 1);
            };

            tabsWrap.querySelectorAll('.dh-tabs-arrow').forEach(function (arrow) {
                arrow.addEventListener('click', function () {
                    var direction = arrow.classList.contains('dh-tabs-prev') ? -1 : 1;
                    tabsNav.scrollBy({ left: direction * tabsNav.clientWidth * 0.7, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
                });
            });

            var activeTabLink = tabsNav.querySelector('.dh-tab.active');
            if (activeTabLink) {
                var navRect = tabsNav.getBoundingClientRect();
                var tabRect = activeTabLink.getBoundingClientRect();
                if (tabRect.left < navRect.left || tabRect.right > navRect.right) {
                    tabsNav.scrollLeft += tabRect.left - navRect.left - (navRect.width - tabRect.width) / 2;
                }
            }

            tabsNav.addEventListener('scroll', updateTabArrows, { passive: true });
            var tabsObserver = new ResizeObserver(updateTabArrows);
            tabsObserver.observe(tabsNav);
            tabsNav.querySelectorAll('.dh-tab').forEach(function (tab) { tabsObserver.observe(tab); });
            updateTabArrows();
        }

        var waveSelector = '.dh-mega-label, .dh-mega-link, .dh-chip, .dh-plain-links a, .dh-promo-card, .dh-rail-links';

        header.querySelectorAll('.dh-mega').forEach(function (mega) {
            mega.querySelectorAll(waveSelector).forEach(function (el) {
                el.classList.add('dh-wave');
            });
        });

        function prepareWave(mega) {
            if (mega.hasAttribute('data-dh-wave')) {
                return;
            }
            mega.setAttribute('data-dh-wave', '');
            mega.querySelectorAll(waveSelector).forEach(function (el) {
                var delay = Math.min(el.offsetLeft / 1400, 1) * 0.28;
                el.style.setProperty('--dh-delay', delay.toFixed(3) + 's');
            });
        }

        function setExpanded(item, expanded) {
            item.classList.toggle('open', expanded);
            item.querySelector('.dh-nav-trigger').setAttribute('aria-expanded', expanded ? 'true' : 'false');
        }

        function closeAll() {
            items.forEach(function (item) { setExpanded(item, false); });
            if (megaBg) {
                megaBg.classList.remove('show');
                megaBg.style.height = '0px';
            }
            document.body.classList.remove('dh-menu-open');
        }

        function open(item) {
            items.forEach(function (other) {
                if (other !== item) {
                    setExpanded(other, false);
                }
            });
            prepareWave(item.querySelector('.dh-mega'));
            setExpanded(item, true);
            if (megaBg) {
                megaBg.style.height = item.querySelector('.dh-mega').offsetHeight + 'px';
                megaBg.classList.add('show');
            }
            document.body.classList.add('dh-menu-open');
        }

        items.forEach(function (item) {
            var trigger = item.querySelector('.dh-nav-trigger');

            item.addEventListener('mouseenter', function () {
                if (!desktopQuery.matches || header.classList.contains('dh-compact')) {
                    return;
                }
                clearTimeout(hoverTimer);
                hoverTimer = setTimeout(function () { open(item); }, 80);
            });

            item.addEventListener('mouseleave', function () {
                if (!desktopQuery.matches || header.classList.contains('dh-compact')) {
                    return;
                }
                clearTimeout(hoverTimer);
                hoverTimer = setTimeout(closeAll, 180);
            });

            trigger.addEventListener('click', function (e) {
                e.stopPropagation();
                clearTimeout(hoverTimer);
                if (item.classList.contains('open')) {
                    closeAll();
                } else {
                    open(item);
                }
            });
        });

        document.addEventListener('click', function (e) {
            if (!e.target.closest('.dh-nav-item')) {
                closeAll();
            }
            dropdowns.forEach(function (dropdown) {
                if (!dropdown.contains(e.target)) {
                    setDropdownOpen(dropdown, false);
                }
            });
        });

        document.addEventListener('keydown', function (e) {
            if (e.key !== 'Escape') {
                return;
            }
            var openItem = items.filter(function (item) { return item.classList.contains('open'); })[0];
            closeAll();
            closeDrawer();
            dropdowns.forEach(function (dropdown) { setDropdownOpen(dropdown, false); });
            if (openItem) {
                openItem.querySelector('.dh-nav-trigger').focus();
            }
        });

        if (backdrop) {
            backdrop.addEventListener('click', function () {
                closeAll();
                closeDrawer();
            });
        }

        desktopQuery.addEventListener('change', function () {
            closeAll();
            closeDrawer();
        });

        var headerOffset = null;

        function updateHeaderOffset() {
            var mainBar = header.querySelector('.dh-tier2');
            var visibleHeight = header.classList.contains('condensed') && mainBar ? mainBar.offsetHeight : header.offsetHeight;
            if (visibleHeight !== headerOffset) {
                headerOffset = visibleHeight;
                document.documentElement.style.setProperty('--dh-header-bottom', visibleHeight + 'px');
            }
        }

        new ResizeObserver(updateHeaderOffset).observe(header);

        var lastY = window.scrollY;
        var upFromY = null;
        var revealDistance = 10;
        var ticking = false;
        window.addEventListener('scroll', function () {
            if (ticking) {
                return;
            }
            ticking = true;
            window.requestAnimationFrame(function () {
                var y = window.scrollY;
                if (y > lastY) {
                    upFromY = null;
                    if (y > 80) {
                        var tier2 = header.querySelector('.dh-tier2');
                        var ratio = window.devicePixelRatio || 1;
                        var collapse = tier2 ? Math.ceil((tier2.getBoundingClientRect().top - header.getBoundingClientRect().top) * ratio) / ratio : 0;
                        header.style.setProperty('--dh-collapse', collapse + 'px');
                        header.classList.add('condensed');
                    }
                } else if (y < lastY && upFromY === null) {
                    upFromY = lastY;
                }
                if (y < 40 || (upFromY !== null && upFromY - y >= revealDistance)) {
                    header.classList.remove('condensed');
                }
                updateHeaderOffset();
                lastY = y;
                ticking = false;
            });
        }, { passive: true });

        function setDropdownOpen(dropdown, isOpen) {
            dropdown.classList.toggle('open', isOpen);
            dropdown.querySelector('[data-dh-dropdown-btn]').setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        }

        dropdowns.forEach(function (dropdown) {
            dropdown.querySelector('[data-dh-dropdown-btn]').addEventListener('click', function (e) {
                e.stopPropagation();
                var isOpen = !dropdown.classList.contains('open');
                dropdowns.forEach(function (other) { setDropdownOpen(other, false); });
                setDropdownOpen(dropdown, isOpen);
            });
        });

        function openDrawer() {
            if (!drawer) {
                return;
            }
            drawer.classList.add('open');
            drawer.setAttribute('aria-hidden', 'false');
            hamburger.setAttribute('aria-expanded', 'true');
            document.body.classList.add('dh-drawer-open');
            document.getElementById('dh-drawer-close').focus();
        }

        function closeDrawer() {
            if (!drawer || !drawer.classList.contains('open')) {
                return;
            }
            drawer.classList.remove('open');
            drawer.setAttribute('aria-hidden', 'true');
            hamburger.setAttribute('aria-expanded', 'false');
            document.body.classList.remove('dh-drawer-open');
            hamburger.focus();
        }

        if (drawer && hamburger) {
            hamburger.addEventListener('click', openDrawer);
            document.getElementById('dh-drawer-close').addEventListener('click', closeDrawer);

            drawer.querySelectorAll('button.dh-acc-trigger').forEach(function (trigger) {
                trigger.addEventListener('click', function () {
                    var accItem = trigger.parentElement;
                    var isOpen = accItem.classList.contains('open');
                    drawer.querySelectorAll('.dh-acc-item.open').forEach(function (other) {
                        other.classList.remove('open');
                        other.querySelector('.dh-acc-trigger').setAttribute('aria-expanded', 'false');
                        other.querySelector('.dh-acc-panel').style.maxHeight = null;
                    });
                    if (!isOpen) {
                        var panel = accItem.querySelector('.dh-acc-panel');
                        accItem.classList.add('open');
                        trigger.setAttribute('aria-expanded', 'true');
                        panel.style.maxHeight = panel.scrollHeight + 'px';
                    }
                });
            });
        }

        var announcement = document.getElementById('dh-announcement');
        var announcementClose = document.getElementById('dh-announcement-close');
        if (announcement && announcementClose) {
            announcementClose.addEventListener('click', function () {
                var cookieName = 'waw-dh-dismissed';
                var now = Math.floor(Date.now() / 1000);
                var days = parseInt(announcement.getAttribute('data-dismiss-days'), 10) || 3;
                var id = announcement.getAttribute('data-id');
                var match = document.cookie.match(new RegExp('(?:^|; )' + cookieName + '=([^;]*)'));
                var entries = (match ? decodeURIComponent(match[1]).split('|') : [])
                    .map(function (entry) { return entry.split(':'); })
                    .filter(function (parts) { return parts.length === 2 && parts[0] !== id && parseInt(parts[1], 10) > now; });
                entries.push([id, String(now + days * 86400)]);
                entries = entries.slice(-10);
                var maxAge = Math.max.apply(null, entries.map(function (parts) { return parseInt(parts[1], 10) - now; }));
                document.cookie = cookieName + '=' + encodeURIComponent(entries.map(function (parts) { return parts.join(':'); }).join('|')) + '; path=/; max-age=' + maxAge + '; SameSite=Lax; Secure';
                announcement.classList.add('dismissed');
                if (reducedMotion.matches) {
                    announcement.remove();
                } else {
                    announcement.addEventListener('transitionend', function () { announcement.remove(); }, { once: true });
                }
            });
        }
    }

    function enableTransitions() {
        window.requestAnimationFrame(function () {
            window.requestAnimationFrame(function () {
                document.querySelectorAll('.dh-preload').forEach(function (el) {
                    el.classList.remove('dh-preload');
                });
            });
        });
    }

    if (document.querySelector('[data-dh-header]') || document.readyState !== 'loading') {
        init();
    } else {
        document.addEventListener('DOMContentLoaded', init);
    }

    if (document.readyState === 'complete') {
        enableTransitions();
    } else {
        window.addEventListener('load', enableTransitions);
    }
})();
